/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './addReservedHandle.defs.js'
export * as $defs from './addReservedHandle.defs.js'
